<template>
  <v-avatar
    :color="color"
    :size="getSize()"
  >
    <v-icon :size="getSize() - 10">
      {{ icon }}
    </v-icon>
  </v-avatar>
</template>

<script>
export default {
  name: 'CaseIcon',
  props: {
    type: {
      type: String,
      required: true
    },
    size: {
      type: String,
    }
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'delivery':
          return 'mdi-hammer-screwdriver';
        case 'support':
          return 'mdi-headset';
        case 'backlog':
          return 'mdi-format-list-checks';
        default:
          return '';
      }
    },
    color() {
      switch (this.type) {
        case 'delivery':
          return 'blue-grey lighten-3';
        case 'support':
          return 'orange lighten-3';
        case 'backlog':
          return 'blue lighten-3';
        default:
          return '';
      }
    }
  },
  methods: {
    getSize() {
      switch (this.size) {
        case 'small':
          return 32;
        case 'x-small':
          return 24;
        default:
          return 48;
      }
    }
  }
}
</script>